import { Client } from '@/../client-generator/generated-clients/configurations';
import axiosInstance from '../utils/axios-instance';

const configurationsClient = new Client('', axiosInstance);

export default configurationsClient;
